import { render, staticRenderFns } from "./ManageSubtitles.vue?vue&type=template&id=7d2e536a&scoped=true&"
import script from "./ManageSubtitles.vue?vue&type=script&lang=ts&"
export * from "./ManageSubtitles.vue?vue&type=script&lang=ts&"
import style0 from "./ManageSubtitles.vue?vue&type=style&index=0&id=7d2e536a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2e536a",
  null
  
)

export default component.exports